var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col md:flex-row gap-4 flex-wrap" },
    [
      _c("paid", { attrs: { data: _vm.paid } }),
      _c("pending", { attrs: { data: _vm.pending } }),
      _c("canceled", { attrs: { data: _vm.canceled } }),
      _c("failed", { attrs: { data: _vm.failed } }),
      _c("others", { attrs: { data: _vm.others } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }